import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchAppTokenByAccessToken({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/encryption/fetch/apptoken/by/accesstoken`, obj)
                    .then(response => {
                        if (response.data.success) {
                            sessionStorage.appToken = response.data.authToken;
                            resolve();
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchAppTokenByAccessToken: ${error.message}`));
            });
        },
        FetchAppTokenByUsernamePIN({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/encryption/fetch/apptoken/by/username/pin`, obj)
                    .then(response => {
                        if (response.data.success) {
                            sessionStorage.appToken = response.data.authToken;
                            resolve();
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchAppTokenByUsernamePIN: ${error.message}`));
            });
        },
    },
};
